// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2JlQN","actionsCol":"EnrolledClinics_actionsCol__1S2px"};